import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

import { Toastr } from "arv-reactcomponents";
import UserInformation from "./UserInformation";
import BodyOverlay from "../BodyOverlay";
import AccountSavedCardDeatils from "./AccountSavedCardDetails";
import MyAccountAccordian from "./MyAccountAccordion";
import AccountAddressList from "./AccountAddressList";
import MyAccountLoyalty from "./MyAccountLoyalty";
import { MYACCOUNTPAGE, pageType, blackboltConfig } from "npmlinks-constants";

let { MY_ACCOUNT_MENU } = MYACCOUNTPAGE;

@inject("AddressStore", "MyAccountStore", "LoyaltyStore")
class MyAccountComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addressLoader: true,
      cardLoader: true,
      loyaltyCardsLoader: true,
    };
    this.getAddresses = this.getAddresses.bind(this);
    this.getSavedCard = this.getSavedCard.bind(this);
    this.getLoyaltyData = this.getLoyaltyData.bind(this);
  }
  componentDidMount() {
    this.getAddresses();
    this.getSavedCard();
    this.getLoyaltyData();
  }
  getAddresses() {
    this.props.AddressStore.getUserAddresses().then(
      () => {
        this.setState({ addressLoader: false });
      },
      () => {
        this.setState({ addressLoader: false });
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: blackboltConfig.ERROR_MSG,
          timeout: 3000,
        });
      },
    );
  }
  getSavedCard() {
    this.props.MyAccountStore.savedCardsDetails().then(
      () => {
        this.setState({ cardLoader: false });
      },
      () => {
        this.setState({ cardLoader: false });
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: blackboltConfig.ERROR_MSG,
          timeout: 3000,
        });
      },
    );
  }
  getLoyaltyData() {
    this.props.LoyaltyStore.getLoyaltyCards().then(
      () => {
        this.setState({ loyaltyCardsLoader: false });
      },
      () => {
        this.setState({ loyaltyCardsLoader: false });
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: blackboltConfig.ERROR_MSG,
          timeout: 3000,
        });
      },
    );
  }

  render() {
    const { addressLoader, cardLoader, loyaltyCardsLoader } = this.state;
    const accordionComponents = {
      "user-information": <UserInformation.component />,
      loyalty: <MyAccountLoyalty.component loader={loyaltyCardsLoader} />,
      "payment-methods": (
        <AccountSavedCardDeatils.component cardLoader={cardLoader} />
      ),
      address: <AccountAddressList.component addressLoader={addressLoader} />,
    };

    // TODO: We can remove this code once Loyalty is confirmed ---
    if (
      !process.env.REACT_APP_ISMYACCOUNTLOYALTY ||
      process.env.REACT_APP_ISMYACCOUNTLOYALTY === "false"
    ) {
      MY_ACCOUNT_MENU = MY_ACCOUNT_MENU.filter(menu => menu.type !== "loyalty");
    }

    return (
      <div className="nwc-grid-container nw-mainbar-col">
        <div className="nw-acnt-content">
          {MY_ACCOUNT_MENU.map(list => (
            <MyAccountAccordian.component
              backgroundColor={list.color}
              iconName={list.iconName}
              title={list.title}
              subtitle={list.subtitle}
              accordionComponent={accordionComponents[list.type]}
              key={list.type}
              hash={list.hash}
            />
          ))}
          <BodyOverlay.component />
        </div>
      </div>
    );
  }
}

MyAccountComponent.wrappedComponent.propTypes = {
  AddressStore: PropTypes.shape({
    getUserAddresses: PropTypes.func.isRequired,
  }).isRequired,
  MyAccountStore: PropTypes.shape({
    savedCardsDetails: PropTypes.func.isRequired,
  }).isRequired,
  LoyaltyStore: PropTypes.shape({
    getLoyaltyCards: PropTypes.func.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("AddressStore", "MyAccountStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: MyAccountComponent.wrappedComponent,
  component: MyAccountComponent,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/MyAccountComponent/index.js